<template>
    <aside class="m-pvx-aside" :class="navStatusClass">
        <div class="u-home-wrap" :class="active === 'pvx' && 'is-active'">
            <span class="u-open" v-if="navStatus !== 2" @click="toRight">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.898 3.382a.635.635 0 01.524.155c.145.124.208.319.207.506-.001.268.008.537-.005.805a.623.623 0 01-.538.584c-.336.06-.687-.213-.706-.555v-.915a.614.614 0 01.518-.58zM4.928 7.562a.634.634 0 01.838.074.633.633 0 01.003.85c-.443.466-.89.928-1.333 1.394h3.203a.597.597 0 01.491.229.634.634 0 01-.078.863c-.131.121-.314.16-.489.158H4.447c.437.463.881.92 1.32 1.382a.63.63 0 01.034.81.633.633 0 01-.875.114c-.087-.075-.164-.159-.242-.242L2.67 11.09c-.088-.098-.196-.183-.254-.304a.63.63 0 01.095-.71c.679-.71 1.359-1.418 2.037-2.128.129-.127.243-.268.38-.386zM9.816 7.463a.633.633 0 01.724.28c.13.223.08.492.09.738-.009.252.041.535-.116.753a.632.632 0 01-.817.19.602.602 0 01-.318-.544v-.84a.61.61 0 01.437-.577zM14.29 7.617c.233-.238.661-.241.888.006.786.815 1.566 1.635 2.35 2.452a.634.634 0 01.121.658c-.066.171-.22.283-.337.418l-1.979 2.067c-.106.107-.202.233-.344.292a.633.633 0 01-.753-.19.631.631 0 01.038-.808c.438-.463.882-.92 1.32-1.383-1.062 0-2.125.004-3.187-.002a.627.627 0 01-.625-.528c-.067-.348.217-.715.574-.72l3.248.001c-.443-.466-.89-.928-1.332-1.394a.634.634 0 01.019-.869zM9.775 11.54a.63.63 0 01.755.25c.14.218.09.488.1.731-.01.262.044.556-.12.783a.634.634 0 01-.882.138.59.59 0 01-.248-.48v-.883a.607.607 0 01.395-.54zM9.82 15.588c.36-.124.78.158.801.538.017.297.01.596.005.893-.002.328-.298.62-.628.604a.612.612 0 01-.618-.581v-.882a.61.61 0 01.44-.572z" fill="#fff"/></svg>
            </span>
            <span class="u-close" v-if="navStatus === 2" @click="toLeft">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'u-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 10.5h-4.667m0 0l2.334 2.438M12.333 10.5l2.334-2.438M3 10.5h4.667m0 0l-2.334 2.438M7.667 10.5L5.333 8.062M10 4v.813m0 3.25v.812m0 3.25v.813m0 3.25V17"/></svg>
            </span>
            <a v-if="navStatus === 2" class="u-home" :class="active" href="/pvx">
                <svg width="21" height="20" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'u-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.833 16.667v-5h3.334v5h4.166V10h2.5L10.5 2.5 2.167 10h2.5v6.667h4.166z"/></svg>
            </a>
            <span class="u-setting is-disabled" v-if="navStatus === 2">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.508 8.485c-.496 0-.96.192-1.313.544-.35.352-.544.817-.544 1.313 0 .497.194.961.544 1.313.352.35.817.545 1.313.545.497 0 .962-.194 1.314-.544.35-.353.544-.817.544-1.314 0-.496-.194-.96-.544-1.313a1.842 1.842 0 00-1.314-.544zm6.845 3.91l-1.086-.929a5.96 5.96 0 000-1.916l1.086-.928a.53.53 0 00.154-.584l-.014-.043a7.345 7.345 0 00-1.322-2.286l-.03-.035a.533.533 0 00-.582-.158l-1.348.48a5.799 5.799 0 00-1.654-.955l-.26-1.409a.532.532 0 00-.429-.427l-.045-.008a7.481 7.481 0 00-2.636 0l-.045.008a.532.532 0 00-.428.427L7.45 5.048A5.868 5.868 0 005.81 6L4.45 5.516a.531.531 0 00-.582.158l-.03.035a7.403 7.403 0 00-1.322 2.286l-.015.043a.533.533 0 00.155.584l1.099.938a5.836 5.836 0 000 1.893l-1.096.938a.532.532 0 00-.154.584l.015.043c.3.835.743 1.607 1.321 2.287l.03.034a.533.533 0 00.583.158l1.358-.483a5.75 5.75 0 001.642.951l.262 1.416a.532.532 0 00.428.427l.045.008a7.442 7.442 0 002.636 0l.045-.008a.531.531 0 00.429-.427l.26-1.41a5.837 5.837 0 001.654-.954l1.348.48a.53.53 0 00.583-.158l.03-.034a7.402 7.402 0 001.32-2.287l.016-.043a.536.536 0 00-.158-.58zm-6.845.866a2.918 2.918 0 110-5.837 2.918 2.918 0 010 5.837z" fill="#fff" fill-opacity=".58"/></svg>
            </span>
        </div>
        <div class="m-pvx-nav" v-if="clientMenus.length">
            <div class="m-nav-group" :class="group.key" v-for="group in clientMenus" :key="group.key">
                <div
                    class="m-nav-item"
                    v-for="item in group.submenus"
                    :key="item.key"
                    :class="[{ 'is-active': active == item.key }, item.key]"
                    v-show="item.status"
                >
                    <a :href="item.path" :target="item.target || '_self'">
                        <div class="u-nav-icon">
                            <img svg-inline :src="require(`../assets/img/nav/${item.key}.svg`)" class="u-icon" />
                            <img svg-inline :src="require(`../assets/img/nav/${item.key}2.svg`)" class="u-icon-hover" />
                        </div>

                        <span>{{ item.label }}</span>
                    </a>
                    <div v-show="navStatus === 1" class="u-nav-label">{{ item.label }}</div>
                </div>
            </div>
        </div>
        <div class="u-btn" v-if="!navStatus" @click="toRight">
            <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10.667 8.708a.875.875 0 01.084 1.746l-.084.004H1.333a.875.875 0 01-.084-1.746l.084-.004h9.334zm0-4.083a.875.875 0 010 1.75H1.333a.875.875 0 010-1.75h9.334zm0-4.083a.875.875 0 010 1.75H1.333a.875.875 0 010-1.75h9.334z" fill="#FFD159"/></svg>
        </div>
        <div class="u-btn" v-if="navStatus" @click="toLeft">
            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M.455 8.526a1.556 1.556 0 010-2.2L6.324.456a1.556 1.556 0 112.2 2.201L3.756 7.426l4.768 4.769a1.557 1.557 0 11-2.2 2.201l-5.87-5.87h.001z" fill="#FFD159"/></svg>
        </div>
        <!-- <div class="u-btn" :class="navStatus === 2 && 'is-disabled'" @click="toRight">
                <i class="el-icon-arrow-right"></i>
            </div> -->
    </aside>
</template>

<script>
import { compact } from "lodash";
import menus from "@/assets/data/menus.json";
export default {
    name: "Nav_V4",
    props: [],
    components: {},
    data: function () {
        return {
            menus: menus,
            navStatus: 1,
        };
    },
    computed: {
        isPhone() {
            return document.documentElement.clientWidth <= 768;
        },
        navStatusClass() {
            let text = "";
            const navStatus = this.navStatus;
            if (navStatus === 0) {
                text = "is-closed";
            } else if (navStatus === 1) {
                text = "is-regular";
            } else {
                text = "is-opened";
            }
            return text;
        },
        active: function () {
            let arr = compact(location.pathname?.split("/"));
            let str = arr[0];
            if (str === "pvg") str = arr[1];
            if (str === "homeland") str = "blueprint";
            if (str === "body") str = "exterior";
            return str;
        },
        client() {
            return this.$store.state.client;
        },
        clientMenus() {
            let menus = this.menus;
            if (this.client !== "std") {
                menus = menus
                    .map((item) => {
                        // if (item.index == "4") return false;
                        item.submenus = item.submenus
                            .map((el) => {
                                // if (el.key == "adventure") return false;
                                // if (el.key == "furniture") return false;
                                // if (el.key == "blueprint") return false;
                                // if (el.key == "exterior") return false;
                                if (el.isStd) return false;
                                return el;
                            })
                            .filter(Boolean);
                        return item;
                    })
                    .filter(Boolean);
            }
            return menus;
        },
        storeNavStatus() {
            return ~~sessionStorage.getItem("navStatus") || 1;
        },
    },
    watch: {
        navStatusClass: {
            immediate: true,
            handler(navStatusClass) {
                this.$emit("statusChange", navStatusClass);
            },
        },
        navStatus: {
            handler(navStatus) {
                sessionStorage.setItem("navStatus", navStatus);
            },
        },
        storeNavStatus: {
            immediate: true,
            handler(val) {
                this.navStatus = val;
            },
        },
    },
    methods: {
        toLeft() {
            if (this.navStatus === 2) {
                this.navStatus = 0;
            } else if (this.navStatus > 0) {
                this.navStatus--;
            }
        },
        toRight() {
            if (this.navStatus < 2) {
                this.navStatus++;
            }
        },
    },
    mounted() {
        if (this.isPhone) {
            this.navStatus = 0;
        }
    },
};
</script>

<style lang="less">
@import "~@/assets/css/nav_v4.less";
</style>
